import { FullscreenExit, Fullscreen } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { cloneDeep } from 'lodash';
import React from 'react';

import theme from '../../theme/theme';

export interface FullScreenToggleProps {
  isFullscreen: boolean;
  setIsFullscreen: Function;
  tooltipFullscreenMessage?: string;
}

export const FullScreenToggleButton: React.FC<FullScreenToggleProps> = ({
  isFullscreen = false,
  tooltipFullscreenMessage,
  setIsFullscreen,
}) => {
  return (
    <IconButton
      size="small"
      sx={{
        position: isFullscreen ? 'fixed' : undefined,
        top: '0px', //1rem
        left: '50%',
        transform: 'translateX(-50%)',
        background: theme.palette.secondary.main,
        '&:hover': {
          background: theme.palette.secondary.dark,
        },
      }}
      onClick={() => {
        const fullscreen = cloneDeep(isFullscreen);
        setIsFullscreen(!fullscreen);
      }}
    >
      {isFullscreen ? (
        <FullscreenExit sx={{ fill: 'white' }} />
      ) : (
        <Tooltip
          key="TooltipFullscreenExitMessage"
          title={tooltipFullscreenMessage ? tooltipFullscreenMessage : ''}
        >
          <Fullscreen sx={{ fill: 'white' }} />
        </Tooltip>
      )}
    </IconButton>
  );
};
